import React from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CompanyProfile from './components/CompanyProfile';
import PhotoGallery from './components/PhotoGallery';
import AboutSection from './components/AboutSection';
import CEOSection from './components/CEOSection';
import ServicesGrid from './components/ServicesGrid';
import Clients from './components/Clients';
import ContactSection from './components/ContactSection';
import TeamSection from './components/TeamSection';
import Footer from './components/Footer';
import ServicesDetailPage from './pages/ServicesDetailPage';

import { Routes, Route } from 'react-router-dom';

const Home = () => (
  <>
    <Hero />
    <CompanyProfile />
    <PhotoGallery />
    <AboutSection />
    <CEOSection />
    <ServicesGrid />
    <Clients />
    <ContactSection />
    <TeamSection />
  </>
);

function App() {
  return (
    <div className="min-h-screen font-sans selection:bg-orange-500 selection:text-white">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesDetailPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
